// extracted by mini-css-extract-plugin
module.exports = {"modifierAmountPercentage":"RateModifierFormItems_modifierAmountPercentage__17NI1"};